__turbopack_context__.v({
  "table": "TaxYearlyReportMobileDetails-module-scss-module__2PU67W__table",
});
